export class ListAggregationServingTokensResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "servingTokens",
            "baseName": "servingTokens",
            "type": "Array<AggregationServingToken>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAggregationServingTokensResponse.attributeTypeMap;
    }
    constructor() {
    }
}
